const TOKEN_KEY = 'authorizationToken';

export interface User{
  auth: string,
  ratt: string,
  sub: string,
  iat: number,
  exp: number
}

function parseJwt(token: string): User {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
}

export function setToken(token: string): void {
  sessionStorage.setItem(TOKEN_KEY, token);
}

export function getToken(): string {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function getInfos(): User {
  return parseJwt(sessionStorage.getItem(TOKEN_KEY));
}

export function logout(): void {
  sessionStorage.removeItem(TOKEN_KEY);
}

export function parseUrl(url: string): { login?: string } {
  const searchObject: { login?: string } = {};
  let split: Array<string> = [];
  const data = url.split('/')[url.split('/').length - 1].replace('?', '&').split('&');
  data.forEach((d) => {
    split = d.split('=');
    searchObject[split[0]] = split[1];
  });
  return searchObject;
}
